/**
 * @typedef {Object} SelectableOption
 * @property {string} label
 * @property {string} value
 */

/**
 * Converte um objeto desconhecido em uma opção selecionável.
 *
 * @param {Object} unknown - O objeto desconhecido a ser convertido.
 * @param {string} fieldToBeUsedAsLabel - O campo do objeto a ser usado como rótulo.
 * @param {string} fieldToBeUsedAsValue - O campo do objeto a ser usado como valor.
 * @returns {SelectableOption} - A opção selecionável.
 */
export function parseUnknownToSelectableOption(unknown, fieldToBeUsedAsLabel, fieldToBeUsedAsValue) {
  if (!unknown || typeof unknown !== 'object') {
    throw new Error('Invalid input: unknown must be an object');
  }

  if (!unknown.hasOwnProperty(fieldToBeUsedAsLabel) || !unknown.hasOwnProperty(fieldToBeUsedAsValue)) {
    throw new Error('Invalid input: unknown must contain the specified fields');
  }

  const label = unknown[fieldToBeUsedAsLabel];
  const value = unknown[fieldToBeUsedAsValue];

  if (typeof label !== 'string' && typeof label !== 'number') {
    throw new Error('Invalid input: label field must be a string or number');
  }

  if (typeof value !== 'string' && typeof value !== 'number') {
    throw new Error('Invalid input: value field must be a string or number');
  }

  return {
    label: String(label),
    value: String(value)
  };
}